import { Component, OnInit, Inject } from '@angular/core';
import { MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ProcedureCodesService } from 'src/app/Services/ProcedureCodes/procedure-codes.service';
import { ToastrService } from 'ngx-toastr';
import { IProcedureCodes } from 'src/app/models/IProcedureCodes';

@Component({
  selector: 'app-master-cpt',
  templateUrl: './master-cpt.component.html',
  styleUrls: ['./master-cpt.component.css']
})
export class MasterCPTComponent implements OnInit {
  cptPopUpMasterForm: FormGroup;
  dataSource = new MatTableDataSource();
  blue: string = '#BAFBC1';
  white: string = '#FFFFF';
  searchresults: string = "";
  fromOrders: boolean = false;
  displayedColumns: string[] = ['cptcode', 'description', 'consumerfriendly'];
  constructor(private formBuilder: FormBuilder, private procedureCodesService: ProcedureCodesService, private toastr: ToastrService,
    public dialogRef: MatDialogRef<MasterCPTComponent>, @Inject(MAT_DIALOG_DATA) public details: DialogData,
    @Inject(MAT_DIALOG_DATA) public data: IProcedureCodes, public dialog: MatDialog) {
    if (details.flagFrom == 'orders') {
      this.fromOrders = true;
    } else {
      this.fromOrders = false;
    }
  }

  ngOnInit() {
    this.cptPopUpMasterForm = this.formBuilder.group({
      MasterCptlist: ['']
    });
    if (this.data != undefined && this.data.cptCode != '') {
      this.cptPopUpMasterForm.controls["MasterCptlist"].setValue(this.data.cptCode);
      this.searchMasterCPTcodes();
    }
  }

  onMasterCptSearch() {
    this.searchMasterCPTcodes();
  }

  public MasterCPTList: IProcedureCodes[];
  searchMasterCPTcodes() {
    var searchText = this.cptPopUpMasterForm.value.MasterCptlist;
    if (searchText != null && searchText != undefined && searchText != '') {
      this.procedureCodesService.getProcedureBySearch(searchText).subscribe(
        results => {
          this.MasterCPTList = results;
          if (results.length == 0) {
            this.searchresults = "No search results found.";
          }
          else {
            this.searchresults = "";
          }
          //   this.MasterCPTList.forEach(element => {
          //     const cptindex = this.MasterCPTList.findIndex(iterator => iterator.activeStatus === element.activeStatus);
          //    //const index = element.activeStatus == true;
          //     this.MasterCPTList[cptindex].background = this.blue;
          //     // for (const iterator of this.MasterCPTList) {
          //     //   if (iterator.activeStatus === true) {
          //     //     var cptindex = this.MasterCPTList.findIndex(iterator => iterator.activeStatus === element.activeStatus);
          //     //     this.MasterCPTList[cptindex].background = this.blue;
          //     //   }
          //     // }
          //   })
          // //   for(let i=0; i<this.MasterCPTList.length; i++){
          // //     var cptindex = this.MasterCPTList.findIndex(iterator => iterator.activeStatus === true);
          // //     this.MasterCPTList[cptindex].background = this.blue;
          // // }
          this.dataSource.data = this.MasterCPTList;
          if (this.MasterCPTList.length == 1 && this.MasterCPTList[0].activeStatus == false) {
            this.MasterCPTList[0].activeStatus = true;
            this.selectedCPTCodes(0, this.MasterCPTList[0], true);
          }
        }, (err: any) => console.log(err));
    }
  }

  public newMasterrecord: IProcedureCodes[] = [];
  selectedCPTCodes(index, element: IProcedureCodes, event: boolean) {
    if (event == true) {
      this.MasterCPTList[index].background = this.blue;
      this.newMasterrecord.push(element);
    } else {
      this.MasterCPTList[index].background = 'white';
      this.newMasterrecord = this.newMasterrecord.filter(ele => ele != element);
    }
  }

  AddCPTMaster() {
    if (this.fromOrders == false) {
      if (this.newMasterrecord.length == 1) {
        this.dialogRef.close(this.newMasterrecord);
      }
      else if (this.newMasterrecord.length > 1) {
        this.toastr.error("Please select only one CPT Code");
      }
      else {
        this.toastr.error("Please select CPT Code");
      }
    } else {
      if (this.newMasterrecord.length == 0) {
        this.toastr.error("Please select CPT Code");
      } else {
        this.dialogRef.close(this.newMasterrecord);
      }
    }
  }
  selectedRowIndex: number = -1;
  oncellclick(row) {
    this.selectedRowIndex = row.cptMasterId;
  }
  CancelCPTMaster() {
    this.dialogRef.close('cancel');
  }
}
export interface DialogData {
  flagFrom: string;
}